/**
 * Detecta si el navegador corre en un dispositivo móvil.
 * Combina user-agent (más fiable para "es un teléfono") con un fallback por ancho de
 * viewport. Pensado para decidir el redirect a la app mobile (`/chat`) en el login y en
 * la raíz; no usa hooks para poder llamarse dentro de efectos/callbacks.
 */
export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false;

  const ua = navigator.userAgent || '';
  const isMobileUA =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);

  const isNarrow =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(max-width: 768px)').matches;

  return isMobileUA || isNarrow;
};
